import React from "react";
import Fa from 'react-fontawesome'

export default class PleaseWaitBox extends React.Component {
    render() {
		return <div className="container-fluid  x-container-fluid">
                <div className="row">
                  <div className ="col-md-12">
                    <div className="alert alert-success" role="alert">
                      <Fa name='cog' spin/>&nbsp;Loading data. Please wait...
                    </div>
                  </div>
                </div>
              </div>  
	}
}



// WEBPACK FOOTER //
// ./src/components/PleaseWaitBox.js